import { WebWorkerMessageHandler } from '../../../../core/web-workers/web-worker-message-handler.model';
import { Store } from '@ngrx/store';
import * as fromCop from 'src/app/modules/cop/store/cop/cop.actions';
import { LoggerService } from 'src/app/modules/core/services/logger/logger.service';
import { Logger, LogLevel } from 'src/app/modules/core/services/logger/logger.model';

export class ProcessDatasetChangeEventHandler implements WebWorkerMessageHandler {
  private logger: Logger;

  public constructor(private store$: Store, private loggerService: LoggerService) {
    this.logger = this.loggerService.getLogger('WebworkerClient.ProcessDatasetChangeEventHandler');
  }

  processMessage(payload: any): void {
    const stopWatch = this.logger.startStopwatch(LogLevel.Info, 'ProcessDatasetChangeEventHandler.processMessage()');

    if (!!payload) {
      setTimeout(() => {
        this.store$.dispatch(fromCop.processSignalRDatasetChangeEvent({ event: payload }));
      }, 1);
    }

    stopWatch.stop();
  }
}
